
import { Link } from 'react-router-dom';
import Navbar from '../../../components/feature/Navbar';
import Footer from '../../../components/feature/Footer';

const FireExtinguisherMaintenancePage = () => {
  const faqs = [
    {
      question: 'Yangın tüpü bakım periyodu ne kadardır?',
      answer: 'Yangın tüpü bakım ve periyodik kontrol işlemleri yılda en az bir kez yapılmalıdır. Bazı tüp tipleri ve kullanım alanlarına göre bu süre 6 aya kadar düşebilir.',
    },
    {
      question: 'Yangın tüpü bakımında neler yapılır?',
      answer: 'Bakım işleminde tüpün gövde kontrolü, basınç kontrolü, hortum ve valf kontrolü, güvenlik pimi kontrolü yapılır. Gerekli durumlarda parça değişimi ve dolum işlemi gerçekleştirilir.',
    },
    {
      question: 'Yangın tüpü bakım fiyatları nedir?',
      answer: 'Bakım fiyatları tüp tipi, boyutu ve yapılacak işlemlere göre değişiklik gösterir. Toplu bakım işlemlerinde özel indirimler sunuyoruz.',
    },
    {
      question: 'Bakım sonrası belge veriliyor mu?',
      answer: 'Evet, her bakım işlemi sonrasında detaylı bakım raporu ve etiketleme yapılır. Bu belgeler yasal zorunluluklar ve sigorta için gereklidir.',
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Section */}
      <section className="relative pt-32 pb-20 bg-gradient-to-br from-primary-600 to-primary-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center text-white">
            <h1 className="font-display font-bold text-5xl md:text-6xl mb-6">
              Yangın Tüpü Bakım ve Periyodik Kontrol
            </h1>
            <p className="text-xl md:text-2xl text-white/90 max-w-3xl mx-auto">
              Yangın güvenliğiniz için düzenli bakım ve profesyonel kontrol hizmeti
            </p>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="prose prose-lg max-w-none">
            <h2 className="font-display font-bold text-3xl text-dark-900 mb-6">
              Yangın Tüpü Bakım Hizmeti
            </h2>
            <p className="text-dark-600 leading-relaxed mb-6">
              <strong>Yangın tüpü bakım</strong> ve periyodik kontrol, yangın güvenliğinizin sürekliliği için hayati önem taşır. İpek Yangın Söndürme olarak, tüm tip yangın söndürme tüplerinin profesyonel bakım ve kontrol hizmetini sunuyoruz.
            </p>
            <p className="text-dark-600 leading-relaxed mb-6">
              Yangın tüpü kontrol işlemleri, yasal düzenlemeler gereği düzenli aralıklarla yapılmalıdır. Bakım ve kontrol işlemleri sırasında tüpün tüm bileşenleri detaylı şekilde incelenir, gerekli testler yapılır ve raporlanır.
            </p>

            <h3 className="font-display font-semibold text-2xl text-dark-900 mb-4 mt-12">
              Yangın Tüpü Bakım Süreci
            </h3>
            <div className="space-y-6 mb-12">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-primary-600 rounded-full flex items-center justify-center text-white font-bold flex-shrink-0">
                  1
                </div>
                <div>
                  <h4 className="font-semibold text-dark-900 mb-2 text-lg">Görsel Kontrol</h4>
                  <p className="text-dark-600">Tüpün gövdesinde çatlak, deformasyon, pas veya hasar kontrolü yapılır.</p>
                </div>
              </div>
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-primary-600 rounded-full flex items-center justify-center text-white font-bold flex-shrink-0">
                  2
                </div>
                <div>
                  <h4 className="font-semibold text-dark-900 mb-2 text-lg">Basınç Kontrolü</h4>
                  <p className="text-dark-600">Manometre üzerinden basınç seviyesi kontrol edilir, yeşil bölgede olması sağlanır.</p>
                </div>
              </div>
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-primary-600 rounded-full flex items-center justify-center text-white font-bold flex-shrink-0">
                  3
                </div>
                <div>
                  <h4 className="font-semibold text-dark-900 mb-2 text-lg">Hortum ve Valf Kontrolü</h4>
                  <p className="text-dark-600">Hortumda çatlak, sertleşme veya tıkanıklık kontrolü, valf mekanizması testi yapılır.</p>
                </div>
              </div>
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-primary-600 rounded-full flex items-center justify-center text-white font-bold flex-shrink-0">
                  4
                </div>
                <div>
                  <h4 className="font-semibold text-dark-900 mb-2 text-lg">Güvenlik Pimi ve Mühür</h4>
                  <p className="text-dark-600">Güvenlik piminin yerinde ve sağlam olduğu, mührün bozulmadığı kontrol edilir.</p>
                </div>
              </div>
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-primary-600 rounded-full flex items-center justify-center text-white font-bold flex-shrink-0">
                  5
                </div>
                <div>
                  <h4 className="font-semibold text-dark-900 mb-2 text-lg">Etiket ve Tarih Kontrolü</h4>
                  <p className="text-dark-600">Son bakım tarihi, dolum tarihi ve bir sonraki kontrol tarihi kontrol edilir.</p>
                </div>
              </div>
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-primary-600 rounded-full flex items-center justify-center text-white font-bold flex-shrink-0">
                  6
                </div>
                <div>
                  <h4 className="font-semibold text-dark-900 mb-2 text-lg">Raporlama ve Etiketleme</h4>
                  <p className="text-dark-600">Bakım raporu hazırlanır, yeni kontrol etiketi yapıştırılır ve belgelendirme tamamlanır.</p>
                </div>
              </div>
            </div>

            <h3 className="font-display font-semibold text-2xl text-dark-900 mb-4">
              Periyodik Kontrol Neden Önemlidir?
            </h3>
            <ul className="list-disc list-inside space-y-3 text-dark-600 mb-8">
              <li>Yangın anında tüpün çalışmaması can ve mal kaybına yol açabilir</li>
              <li>Yasal düzenlemeler düzenli bakım ve kontrol zorunluluğu getirir</li>
              <li>İş güvenliği mevzuatına uyum sağlanır</li>
              <li>Sigorta şirketleri güncel bakım kayıtları talep eder</li>
              <li>Erken tespit edilen sorunlar büyük hasarları önler</li>
              <li>Tüpün ömrü uzar ve performansı korunur</li>
            </ul>

            <h3 className="font-display font-semibold text-2xl text-dark-900 mb-4">
              Hangi Durumlarda Bakım Gerekir?
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8">
              <div className="bg-primary-50 rounded-lg p-4 border-l-4 border-primary-600">
                <p className="text-dark-700 font-medium">Yıllık periyodik kontrol zamanı geldiğinde</p>
              </div>
              <div className="bg-primary-50 rounded-lg p-4 border-l-4 border-primary-600">
                <p className="text-dark-700 font-medium">Basınç göstergesi kırmızı bölgede ise</p>
              </div>
              <div className="bg-primary-50 rounded-lg p-4 border-l-4 border-primary-600">
                <p className="text-dark-700 font-medium">Tüp kullanıldıktan sonra</p>
              </div>
              <div className="bg-primary-50 rounded-lg p-4 border-l-4 border-primary-600">
                <p className="text-dark-700 font-medium">Gövdede hasar veya pas görüldüğünde</p>
              </div>
              <div className="bg-primary-50 rounded-lg p-4 border-l-4 border-primary-600">
                <p className="text-dark-700 font-medium">Hortum veya valf arızası tespit edildiğinde</p>
              </div>
              <div className="bg-primary-50 rounded-lg p-4 border-l-4 border-primary-600">
                <p className="text-dark-700 font-medium">Güvenlik pimi veya mühür bozulduğunda</p>
              </div>
            </div>

            <h3 className="font-display font-semibold text-2xl text-dark-900 mb-4">
              Kimler İçin Uygun?
            </h3>
            <p className="text-dark-600 leading-relaxed mb-4">
              Yangın tüpü bakım hizmetimiz, yangın söndürme tüpü bulunduran tüm işletmeler ve bireyler için uygundur:
            </p>
            <ul className="list-disc list-inside space-y-2 text-dark-600 mb-8">
              <li>Restoranlar, kafeler ve oteller</li>
              <li>Fabrikalar ve üretim tesisleri</li>
              <li>Depolar ve lojistik merkezler</li>
              <li>Ofisler ve iş merkezleri</li>
              <li>Alışveriş merkezleri ve mağazalar</li>
              <li>Apartman ve site yönetimleri</li>
              <li>Eğitim kurumları</li>
              <li>Sağlık tesisleri</li>
            </ul>

            <h3 className="font-display font-semibold text-2xl text-dark-900 mb-4">
              Servis Bölgelerimiz
            </h3>
            <p className="text-dark-600 leading-relaxed mb-8">
              [Şehir] ve tüm ilçelerinde yangın tüpü bakım ve periyodik kontrol hizmeti vermekteyiz. Toplu bakım işlemlerinde özel fiyat avantajlarından yararlanabilirsiniz.
            </p>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-20 bg-dark-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="font-display font-bold text-3xl text-dark-900 mb-12 text-center">
            Bakım Hizmetimizin Avantajları
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="w-20 h-20 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-calendar-check-line text-4xl text-primary-600"></i>
              </div>
              <h3 className="font-display font-semibold text-lg text-dark-900 mb-2">Hatırlatma Sistemi</h3>
              <p className="text-dark-600 text-sm">Bir sonraki bakım zamanı geldiğinde sizi bilgilendiriyoruz</p>
            </div>
            <div className="text-center">
              <div className="w-20 h-20 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-file-text-line text-4xl text-primary-600"></i>
              </div>
              <h3 className="font-display font-semibold text-lg text-dark-900 mb-2">Detaylı Raporlama</h3>
              <p className="text-dark-600 text-sm">Her bakım sonrası kapsamlı rapor ve belgelendirme</p>
            </div>
            <div className="text-center">
              <div className="w-20 h-20 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-team-line text-4xl text-primary-600"></i>
              </div>
              <h3 className="font-display font-semibold text-lg text-dark-900 mb-2">Uzman Ekip</h3>
              <p className="text-dark-600 text-sm">Sertifikalı ve deneyimli teknisyenlerimiz</p>
            </div>
            <div className="text-center">
              <div className="w-20 h-20 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-price-tag-3-line text-4xl text-primary-600"></i>
              </div>
              <h3 className="font-display font-semibold text-lg text-dark-900 mb-2">Uygun Fiyat</h3>
              <p className="text-dark-600 text-sm">Toplu bakımlarda özel indirimler</p>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="font-display font-bold text-3xl text-dark-900 mb-12 text-center">
            Sık Sorulan Sorular
          </h2>
          <div className="space-y-6">
            {faqs.map((faq, index) => (
              <div key={index} className="bg-dark-50 rounded-lg p-6 border-l-4 border-primary-600">
                <h3 className="font-display font-semibold text-xl text-dark-900 mb-3">
                  {faq.question}
                </h3>
                <p className="text-dark-600 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-primary-600">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="font-display font-bold text-4xl md:text-5xl text-white mb-6">
            Yangın Tüpü Bakımı İçin Randevu Alın
          </h2>
          <p className="text-xl text-white/90 mb-8 max-w-2xl mx-auto">
            Profesyonel bakım hizmeti ile yangın güvenliğinizi garanti altına alın
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <a 
              href="tel:+905XXXXXXXXX" 
              className="bg-white text-primary-600 px-8 py-4 rounded-lg font-semibold text-lg hover:bg-dark-50 transition-all hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer inline-flex items-center space-x-2"
            >
              <i className="ri-phone-line"></i>
              <span>Hemen Ara</span>
            </a>
            <a 
              href="https://wa.me/905XXXXXXXXX" 
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="bg-green-500 text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-green-600 transition-all hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer inline-flex items-center space-x-2"
            >
              <i className="ri-whatsapp-line"></i>
              <span>WhatsApp</span>
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default FireExtinguisherMaintenancePage;
